export default __webpack_public_path__ + "static/media/a023-short4.22614b52.jpg";